module.exports = ".thumbnail {\n    width : 80px;\n    height: 80px;\n    border-radius:100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shopping-cart/shopping-cart.component.css
// module id = ./src/app/shopping-cart/shopping-cart.component.css
// module chunks = main